import { Drawer, Toolbar, Box, useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LAST_MILE_TABS } from './LastMileTabsList';
import { cloneDeep } from 'lodash';
import { DrawerList, DrawerAccountWelcome } from '../components';
import { useLocation } from 'react-router-dom';
import { USER_ROLES_TYPES } from 'src/constants';
import { useMemo } from 'react';
import { useGetDeliverySettingQuery } from 'src/_api/authApi';
import { omitNestedObject } from 'src/_utils';
import { Paid } from '@mui/icons-material';

const drawerWidth = 270;

export default function MapitDrawer({ openDrawer, toggleDrawer }) {
    const { pathname } = useLocation();
    const { data: deliverySetting } = useGetDeliverySettingQuery()

    const profile = useSelector((state) => state.entities.profile.profile);

    const downLg = useMediaQuery(theme => theme.breakpoints.down('lg'));

    useEffect(() => {
        if (downLg && openDrawer) {
            toggleDrawer();
        }
    }, [pathname, downLg]);

    const TabsList = useMemo(() => {
        let tabs = cloneDeep(LAST_MILE_TABS)

        if (profile?.type !== USER_ROLES_TYPES.ADMIN) {
            tabs = tabs?.filter(el => el.title !== "Account")
        }

        if (!deliverySetting?.reschduleDeliveryDate) {
            if (!!deliverySetting?.ordersCount) return tabs
            tabs = omitNestedObject(tabs, 'title', 'Rescheduled Orders');
        }

        if (!profile?.merchant?.onlinePayment) {
            tabs = tabs?.filter(el => el.href !== "/merchant/transactions")
        }

        if (!!profile?.merchant?.salla?.store_id || !!profile?.merchant?.zid?.store_id) {
            let index = tabs?.findIndex(el => el.title === "Account")
            tabs[index].children = tabs[index]?.children?.filter(el => !["/merchant/account/plans", "/merchant/account/subscription"].includes(el.href))
        }

        if (profile?.merchant?.onlinePayment) {
            tabs.splice(14, 0, {
                href: "/merchant/cod-invoices",
                icon: Paid,
                title: "COD Wallet",
            })
        }

        if (!profile?.merchant?.isNationalAddressEnabled) {
            tabs = tabs?.filter(el => !["/merchant/national-address-transactions"].includes(el.href))
        }

        return tabs
    }, [profile, deliverySetting])

    return (
        <Drawer
            open={openDrawer}
            onClose={toggleDrawer}
            variant={downLg ? "temporary" : "permanent"}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            }}
        >
            <Toolbar />
            <Box sx={{ overflowY: 'auto', overflowX: 'hidden' }}>
                <DrawerAccountWelcome companyName={profile?.merchant?.companyName} logo={profile?.merchant?.logo} />
                {/* {
                    !!profile?.merchant?.currentStatus && includes(["BLOCKED", "WAITING", "ORDER_PLAN_SELECTED"], profile?.merchant?.currentStatus) &&
                    <DrawerCurrentUserStatus currentStatus={profile?.merchant?.currentStatus} />
                } */}
                <DrawerList tabs={TabsList} />
            </Box>
        </Drawer>
    )
}